import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable, map } from "rxjs";

import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";

@Injectable({
  providedIn: "root",
})
export class GetCoachPhoneNumberWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(token: string, matchid: string): Observable<string> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.GET_COACH_PHONE_NUMBER_ENDPOINT())
      .setMethod(HttpMethod.get)
      .setUrlParams({ matchid })
      .setAuthorization(new TokenAuthorization(token))
      .build();
    return this.baseHandler
      .execute(parameters)
      .pipe(map((response) => response.phone));
  }
}
